import axios from "axios"
import headers from "./Header"

class AuthService {
  isTokenValid() {
    return axios.get("/is-token-valid", {
      headers: headers(),
    })
  }

  getUsers() {
    return axios.get("/users", {
      headers: headers(),
    })
  }

  getUsersApproval() {
    return axios.get("/users-approval", {
      headers: headers(),
    })
  }

  addUser(data) {
    return axios.post("user/add", data, {
      headers: headers(),
    })
  }

  putUser(data) {
    return axios.put("user/update", data, {
      headers: headers(),
    })
  }

  approvalUser(data) {
    return axios.put("/user/approval", data, {
      headers: headers(),
    })
  }

  changePassword(data) {
    return axios.put("user/change_password", data, {
      headers: headers(),
    })
  }

  delUser(data) {
    return axios.delete("user/delete", {
      headers: headers(),
      data: data,
    })
  }

  getPegawaiByUsername(username) {
    return axios.get("/search-by-username/" + username, {
      headers: headers(),
    })
  }

  getDivisi() {
    return axios.get("/get-divisi", {
      headers: headers(),
    })
  }

  getRoles(param) {
    return axios.get(
      "/roles" + (typeof param === "undefined" ? "" : param),
      {
        headers: headers(),
      }
    )
  }

  addRole(data) {
    return axios.post("role/add", data, {
      headers: headers(),
    })
  }

  delRole(data) {
    return axios.delete("role/delete", {
      headers: headers(),
      data: data,
    })
  }

  getRolesInUser(id) {
    return axios.get("/roles/in-user/" + id, {
      headers: headers(),
    })
  }

  getRolesNotinUser(id) {
    return axios.get("/roles/not-in-user/" + id, {
      headers: headers(),
    })
  }

  addUserRole(data) {
    return axios.post("user-role/add", data, {
      headers: headers(),
    })
  }

  delUserRole(data) {
    return axios.delete("user-role/delete", {
      headers: headers(),
      data: data,
    })
  }

  getOrganizations(param) {
    return axios.get(
      "/organization" + (typeof param === "undefined" ? "" : param),
      {
        headers: headers(),
      }
    )
  }

  addOrganization(data) {
    return axios.post("organization/add", data, {
      headers: headers(),
    })
  }

  delOrganization(data) {
    return axios.delete("organization/delete", {
      headers: headers(),
      data: data,
    })
  }

  register(data) {
    return axios.post("api/user/register-pmse", data)
  }

  verifyEmail(code) {
    return axios.get("api/verify-user/?code=" + code)
  }
}

export default new AuthService()
